import React from 'react';

const NotificationsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/notifications',
			exact: true,
			component: React.lazy(() => import('./NotificationsPage')),
		},
	],
};

export default NotificationsPageConfig;
